import React, { useEffect, useState } from 'react';
import { DateBox, TimeBox } from './components/DatetimeBox';
import Odometer from './components/Odometer';
import Score, { IScoreboard } from '../../services/api/Scoreboard';
import Loading from '../../components/Loading';
import Select from '../../components/Form/Select';

import './assets/css/style.css';
import Formatter from '../../services/utils/Formatter';

interface ScoreboardProps {
  display: boolean;
}

const ScoreboardCaption: React.FC = () => {
  return (
    <footer>
      <span className='circle red'></span>
      <span className='value'> &lt; 50%</span>

      <span className='circle yellow'></span>
      <span className='value'>50% - 99%</span>

      <span className='circle green'></span>
      <span className='value'>100%</span>
    </footer>
  );
};

const Scoreboard: React.FC<ScoreboardProps> = ({ display }) => {
  const date = new Date();
  // Se o mês for janeiro (0), ajusta para dezembro do ano anterior
  if (date.getMonth() === 0) {
    date.setFullYear(date.getFullYear() - 1);  // Ajusta o ano para o anterior
    date.setMonth(11);  // Define o mês como dezembro (11)
  } else {
    date.setMonth(date.getMonth() - 1);  // Subtrai 1 do mês, caso não seja janeiro
  }

  const [loading, isLoading] = useState<Boolean>(true);
  const [score, setScore] = useState<IScoreboard>({} as IScoreboard);
  const [scoreYtd, setScoreYtd] = useState<IScoreboard>({} as IScoreboard);
  const [Percent, setPercent] = useState<number>(0);
  const [tcre, setCre] = useState<string>('BP');
  const [displayMenu, setDisplayMenu] = useState<Boolean>(false);

  useEffect(() => {
    Promise.all([
      Score.GetByCode('LATAM', date.getFullYear(), date.getMonth() + 1),
      Score.GetYTDByCode('LATAM', date.getFullYear(), date.getMonth() + 1),
    ])
      .then((value) => {
        setScore(value[0]);
        setScoreYtd(value[1]);

        isLoading(false);
      })
      .catch(() => undefined);
  }, []);

  function updateTicker(value: number, percent: number) {
    setPercent(percent);
  }

  return (
    <div className='scoreboard-body'>
      <div className='scoreBoard-wrapper'>
        <div className='row top'>
          {loading ? (
            <Loading />
          ) : (
            <React.Fragment>
              <div className={'panel-settings' + (displayMenu ? ' panel-settings--opened' : '')}>
                <a className='panel-settings__open'
                  onClick={(event: React.FormEvent<HTMLElement>) => {
                    setDisplayMenu(!displayMenu);
                  }}>
                  <svg
                    width='24'
                    height='24'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <defs>
                      <filter colorInterpolationFilters='auto' id='a'>
                        <feColorMatrix
                          in='SourceGraphic'
                          values='0 0 0 0 0.337255 0 0 0 0 0.521569 0 0 0 0 0.921569 0 0 0 1.000000 0'
                        />
                      </filter>
                    </defs>
                    <g
                      transform='translate(-28 -20)'
                      filter='url(#a)'
                      fill='none'
                      fillRule='evenodd'
                      strokeLinecap='square'
                    >
                      <g
                        transform='translate(29 21)'
                        stroke='#212121'
                        strokeWidth='2'
                      >
                        <path d='M22 11a2 2 0 00-2-2h-1.262a7.968 7.968 0 00-.852-2.058l.892-.892a2 2 0 10-2.828-2.828l-.892.892A7.968 7.968 0 0013 3.262V2a2 2 0 00-4 0v1.262a7.968 7.968 0 00-2.058.852l-.892-.892A2 2 0 103.222 6.05l.892.892A7.968 7.968 0 003.262 9H2a2 2 0 000 4h1.262c.189.732.477 1.422.852 2.058l-.892.892a2 2 0 102.828 2.828l.892-.892A7.953 7.953 0 009 18.738V20a2 2 0 004 0v-1.262a7.968 7.968 0 002.058-.852l.892.892a2 2 0 102.828-2.828l-.892-.892A7.953 7.953 0 0018.738 13H20a2 2 0 002-2z' />
                        <circle cx='11' cy='11' r='3' />
                      </g>
                    </g>
                  </svg>
                </a>
                <div className='panel-settings__select-container'>
                  vs
                  <Select
                    name='tcre'
                    title='CRE'
                    options={[
                      { value: 'BP', label: 'BP' },
                      { value: 'SRE', label: 'SRE' },
                      { value: 'FRE', label: 'FRE' },
                    ]}
                    value={tcre}
                    handleChange={(
                      event: React.FormEvent<HTMLSelectElement>
                    ) => {
                      setCre(event.currentTarget.value);
                    }}
                  />
                </div>
              </div>
              <div className='mainData'>
                <Odometer
                  score={score}
                  scoreYtd={scoreYtd}
                  actual={"FW1"}
                  cre={tcre}
                  useHeader={false}
                  date={date}
                  onUpdate={updateTicker}
                />
              </div>
              <div className='info'>
                <div className='grid grid-2'>
                  <div className='box' id='place'>
                    <p>{score.name}</p>
                  </div>
                  <DateBox initialDate={date} />
                  <div className='box' id='percent'>
                    <p id='percentNumber'>
                      {Formatter.DisplayPercent(Percent, false)}
                      <sup>%</sup> <sup>VS {tcre}</sup>
                    </p>
                    <p>{score.code} Actual</p>
                  </div>
                  <TimeBox initialDate={date} />
                </div>
              </div>
            </React.Fragment>
          )}
        </div>
        {loading ? null : (
          <div className='grid grid-3'>
            {score.children.map((obj: IScoreboard, i: number) => {
              return (
                <Odometer
                  isCountry={true}
                  key={obj.id}
                  score={obj}
                  scoreYtd={scoreYtd.children[i]}
                  actual={"FW1"}
                  cre={tcre}
                  date={date}
                />
              );
            })}
          </div>
        )}
        <ScoreboardCaption />
      </div>
    </div>
  );
};

export default Scoreboard;
